import { useEffect, useState } from 'react';

export interface CookedItem {
  productId: string;
  name: string;
}

export function CookedModal({
  items,
  onConfirm,
  onClose,
}: {
  items: CookedItem[];
  onConfirm: (productIds: string[]) => void;
  onClose: () => void;
}) {
  const [checked, setChecked] = useState<Set<string>>(() => new Set());

  function toggle(productId: string) {
    setChecked((prev) => {
      const next = new Set(prev);
      if (next.has(productId)) next.delete(productId);
      else next.add(productId);
      return next;
    });
  }

  // Закрытие по Escape — как у UpgradeModal (единая логика модалок).
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Что закончилось"
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-4 sm:items-center"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-bold text-ink">Что из этого закончилось?</h2>

        {items.length === 0 ? (
          <>
            <p className="mt-3 text-sm text-ink/70">В холодильнике нет продуктов из этого рецепта.</p>
            <button
              onClick={onClose}
              className="mt-5 w-full rounded-xl bg-primary-600 px-4 py-3 font-semibold text-white shadow-card active:scale-[0.98]"
            >
              Закрыть
            </button>
          </>
        ) : (
          <>
            <p className="mt-1 text-sm text-ink/60">Отметьте, что закончилось — уберём из холодильника.</p>
            <ul className="mt-3 space-y-1">
              {items.map((i) => (
                <li key={i.productId}>
                  <label className="flex items-center gap-3 rounded-xl px-2 py-2 active:bg-cream">
                    <input
                      type="checkbox"
                      checked={checked.has(i.productId)}
                      onChange={() => toggle(i.productId)}
                      className="h-5 w-5 accent-primary-600"
                    />
                    <span className="text-ink">{i.name}</span>
                  </label>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex gap-2">
              <button
                onClick={onClose}
                className="flex-1 rounded-xl bg-white px-4 py-3 font-semibold text-ink shadow-sm ring-1 ring-inset ring-ink/10 active:scale-[0.98]"
              >
                Отмена
              </button>
              <button
                onClick={() => onConfirm([...checked])}
                className="flex-1 rounded-xl bg-primary-600 px-4 py-3 font-semibold text-white shadow-card active:scale-[0.98]"
              >
                Убрать отмеченные
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
